import styled from "styled-components";

import Spring from "../../../components/Spring";

export const StyledTerms = styled(Spring)`
    background-color: ${p => p.theme.c.snow};
    padding: 1px 20px 20px;
    position: relative;
    line-height: 28px;

    p {
        text-align: justify;
    }
`;
